export default __webpack_public_path__ + "static/media/banner_premiossume.ac593470.jpg";